import { type DataProvider as RaDataProvider, fetchUtils } from 'react-admin'
import simpleRestProvider from 'ra-data-simple-rest'
import { isNil } from 'lodash/fp'
import jsonProvider from 'ra-data-fakerest'

import { getCustomHeaders, url } from './functions'

const fetchJson = (url: string, options: fetchUtils.Options = {}): any => {
  const customHeaders = getCustomHeaders(options)
  if (isNil(customHeaders)) return undefined
  options.headers = customHeaders
  return fetchUtils.fetchJson(url, options)
}

export const DataProvider = (): RaDataProvider =>
  'TEST' in process.env
    ? {
        ...jsonProvider({
          partners: [
            {
              id: '0-0-0-0-1-0',
              partner: '株式会社ABC',
              product: 'ABC見守りサービス',
              orderByUser: true,
              agreement: {
                name: 'ABC見守りサービス利用規約',
                url: 'https://foo.bar/agreement'
              }
            }
          ],
          users: [
            {
              id: '0-0-0-0-1',
              lastName: '太郎',
              firstName: 'テスト',
              address: '愛知県名古屋市中区栄',
              necessaryEKYC: true,
              place: 'テスト住宅',
              placeNumber: '101',
              service: 'ABC見守りサービス'
            }
          ]
        })
      }
    : {
        ...simpleRestProvider(url, fetchJson)
      }
